import { AUTH_ATTEMPT } from 'hb-react/shared/constants/storageKeys';

export const setAuthAttempt = (method: string) => {
  sessionStorage.setItem(
    AUTH_ATTEMPT.key,
    JSON.stringify({
      type: AUTH_ATTEMPT.types.SIGNIN,
      method,
    }),
  );
};

export const clearAuthAttempt = () => {
  sessionStorage.removeItem(AUTH_ATTEMPT.key);
};

export const METHODS = {
  MFA: 'mfa',
  SSO: 'sso',
  EMAIL: 'email',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
};
